<template>
    <div>
        <Head title="Requests" />
        <h1 class="mb-8 text-3xl font-bold">Api Leads</h1>
        <div class="bg-white rounded-md shadow overflow-x-auto">
            <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                    <th class="pb-4 pt-6 px-6">ID</th>
                    <th class="pb-4 pt-6 px-6">Firstname</th>
                    <th class="pb-4 pt-6 px-6">Lastname</th>
                    <th class="pb-4 pt-6 px-6">Email</th>
                    <th class="pb-4 pt-6 px-6">Phone</th>
                    <th class="pb-4 pt-6 px-6">ZIP</th>
                    <th class="pb-4 pt-6 px-6">City</th>
                    <th class="pb-4 pt-6 px-6">Street</th>
                    <th class="pb-4 pt-6 px-6">House</th>
                    <th class="pb-4 pt-6 px-6">Referer</th>
                    <th class="pb-4 pt-6 px-6">Affiliate</th>
                    <th class="pb-4 pt-6 px-6">UTM Source</th>
                    <th class="pb-4 pt-6 px-6">UTM Content</th>
                    <th class="pb-4 pt-6 px-6">UTM Campaign</th>
                    <th class="pb-4 pt-6 px-6">UTM Keyword</th>
                    <th class="pb-4 pt-6 px-6">Special Mark</th>
                </tr>

                <tr v-for="request in requests" :key="request.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                    <td class="border-t">
<!--                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/api-leads/${request.id}/edit`">-->
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ request.id }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ request.firstname }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ request.lastname }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ request.email }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ request.phone }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ request.zip }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ request.city }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ request.street }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ request.house }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ request.referer }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ request.affiliate }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ request.utm_source }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ request.utm_content }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ request.utm_campaign }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ request.utm_keyword }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ request.special_mark }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`#`">
                            {{ request.created_at }}
                        </Link>
                    </td>
                </tr>
                <tr v-if="requests.length === 0">
                    <td class="px-6 py-4 border-t" colspan="4">No requests found.</td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchInput from '@/Shared/SearchInput'

export default {
    components: {
        Head,
        Icon,
        Link,
        SearchInput,
    },
    layout: Layout,
    props: {
        filters: Object,
        requests: Array,
    },
    data() {
        return {
            form: {
                search: this.filters.search
            },
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get('/api-leads', pickBy(this.form), { preserveState: true })
            }, 150),
        },
    },
    methods: {
        reset() {
            this.form = mapValues(this.form, () => null)
        },
    },
}
</script>
